import script from "./NewRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./NewRegister.vue?vue&type=script&setup=true&lang=js"

import "./NewRegister.vue?vue&type=style&index=0&id=4244b87e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4244b87e"]])

export default __exports__